export const removeNullishItems = <T>(items: (T | null | undefined)[]): T[] => {
    return items.filter((item): item is T => item !== null && item !== undefined);
};
